import React, {useEffect} from 'react';
import BootstrapCard from "../BootstrapCard";
import SearchComponent from "../SearchComponent";
import ModalComponent from "./ModalComponent";
import {useDispatch, useSelector} from "react-redux";
import {
    deleteItemConfirmation,
    getInstallations, getInstallationsPagination,
    installationsLoader,
} from "../../redux-store/selectors";
import {getAllInstallations, openModal} from "../../redux-store/installations";
import ConfirmationDialog from "../ConfirmationDialog";
import Loader from "../ApplicationComponent/Loader";
import {Pagination} from "antd";

const Installations = () => {
    const dispatch = useDispatch();
    const installationsItem = useSelector(getInstallations)
    const deleteDialog = useSelector(deleteItemConfirmation)
    const fetchLoader = useSelector(installationsLoader)
    const {total, pageSize, currentPage} = useSelector(getInstallationsPagination);

    const handleShowModal = () => {
        dispatch(openModal())
    }

    useEffect(() => {
        dispatch(getAllInstallations({}));
    }, [])

    const handleSearch = async (searchVal) => {
        dispatch(getAllInstallations({searchVal}));
    }

    return (
        <div className={"container-fluid pt-3 p-side installations-height"}>
            <div className={"row"}>
                <div className={"col-12 col-sm-6 col-lg-6 col-xl-6"}>
                    <h2>Instalacije</h2>
                </div>
                <div className={"col-12 col-sm-6 col-lg-6 col-xl-6 text-right"}>
                    <button className={"btn btn-main"} onClick={handleShowModal}>Dodaj instalaciju</button>
                </div>
            </div>
            <div className={"row pt-3"}>
                <div className={"col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"}>
                    <SearchComponent handleSearchSubmit={handleSearch}/>
                </div>
            </div>
            {fetchLoader ?
                <Loader/> :
                (
                    <>
                        <div className={"row pt-1"}>
                            {installationsItem.map((item, key) => (
                                <div className={"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 installation-card"}
                                     key={key}>
                                    <BootstrapCard data={item}/>
                                </div>
                            ))}
                        </div>
                        <div className={"row text-right"}>
                            <Pagination defaultCurrent={1}
                                        current={currentPage + 1}
                                        total={total}
                                        showSizeChanger={false}
                                        onChange={(newPage) => {
                                            dispatch(getAllInstallations({
                                                page: newPage - 1,
                                                pageSize
                                            }));
                                        }}/>
                        </div>
                    </>
                )
            }
            <ModalComponent/>
            {deleteDialog && <ConfirmationDialog/>}
        </div>
    );
}

export default Installations;
